<template>
    <div>
        <div class="justify-content-center d-none d-lg-flex">
            <div class="contact-form mb-md-4 text-center" style="position: absolute !important; background-color: unset !important; box-shadow: none !important;">
                <div class="contact-form-dot-pattern">
                    <img src="/images/dot-pattern-blue.png">
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center mt-4 mt-md-5 contact-form-parent">
            <div class="contact-form mb-md-4 text-center">
                <div v-if="formSubmitted" style="padding: 3.2rem 0 !important;">
                    <!--                <h1>{{$t('general.contact_from_title')}}</h1>-->
                    <div class="d-inline-block checked-mark circle small mb-4">
                        <i class="fas fa-check center"></i>
                    </div>
                    <p>{{$t('general.contact_from_submitted_line_1')}}</p>
                    <p>{{$t('general.contact_from_submitted_line_2')}}</p>
                    <p><strong>{{$t('general.contact_from_submitted_line_3')}}</strong></p>
                    <p><strong>{{$t('general.contact_phone')}}</strong></p>
                    <p><strong>{{$t('general.contact_email')}}</strong></p>
                </div>

                <div v-else>
                    <h1 class="mb-5">{{$t('general.contact_from_title')}}</h1>
                    <form @submit.prevent="submit">
                        <google-recaptcha-v3
                            v-on:input="updateRecaptcha"
                            ref="captchaContact"
                            :site-key="this.$recaptchaKey"
                            id="contact_id"
                            action="contact"
                        ></google-recaptcha-v3>

                        <div class="row">
                            <div class="col-12 col-md-6 pr-md-2 pb-4">
                                <input-with-validation
                                    :value="item.name"
                                    :title="$t('fields.your_name')"
                                    :name="'name'"
                                    :style-class="'form-control'"
                                    :type="'text'"
                                    :errors="errors"
                                    :name-type="'placeholder'"
                                    :use-u-i-d="true"
                                    @onInput="changeName"/>
                            </div>
                            <div class="col-12 col-md-6 pb-4">
                                <input-with-validation
                                    :value="item.email"
                                    :title="$t('fields.your_email')"
                                    :name="'email'"
                                    :style-class="'form-control'"
                                    :type="'email'"
                                    :errors="errors"
                                    :name-type="'placeholder'"
                                    :use-u-i-d="true"
                                    @onInput="changeEmail"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 pb-4">
                                <input-with-validation
                                    :value="item.message"
                                    :title="$t('fields.your_message')"
                                    :name="'message'"
                                    :style-class="'form-control'"
                                    :type="'textarea'"
                                    :errors="errors"
                                    :name-type="'placeholder'"
                                    :rows="'4'"
                                    :use-u-i-d="true"
                                    @onInput="changeMessage"/>
                            </div>
                        </div>
                        <div class="text-left d-flex flex-column flex-md-row align-items-center">
                            <button type="submit" class="btn btn-primary mt-4 mt-md-0 mr-md-4 mb-0 order-1 order-md-0" :disabled="loading">
                                <span v-if="!loading">
                                    {{ $t('general.send')}}
                                </span>

                                <div class="spinner-border loading-spinner" role="status" v-if="loading">
                                    <span class="sr-only"></span>
                                </div>
                            </button>
                            <input-with-validation
                                :value="item.agree"
                                :name="'agree'"
                                :main-div-class="'d-inline-flex align-items-center checkbox order-0 order-md-1'"
                                :checkboxMessage="$t('fields.accept_privacy_message')"
                                :style-class="'regular-checkbox'"
                                :type="'custom-checkbox'"
                                :errors="errors"
                                :use-u-i-d="true"
                                style="margin-bottom: 0 !important;"
                                @onInput="changeAgree"/>
                        </div>

                        <div class="custom-error-message" v-if="errors && errors.error_message">
                            <p>{{errors.error_message}}</p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Vue from 'vue';
    import GoogleRecaptchaV3 from "../../components/googlerecaptchav3/GoogleReCaptchaV3";

    export default {
        components: {GoogleRecaptchaV3},
        data() {
            return {
                data: [],
                formSubmitted: false,
                errors: null,
                gRecaptchaResponse: null,
            }
        },
        created() {
            var app = this;
            this.$vueEventBus.$on('clear-errors', function () {
                app.errors = null;
            });
        },
        mounted() {
            document.getElementsByClassName('contact-form')[0].addEventListener('resize', this.resizeForm);
        },
        computed: {
            ...mapGetters('ContactFormSingle', ['item', 'loading']),
        },
        methods: {
            ...mapActions('ContactFormSingle', ['send', 'setName', 'setEmail', 'setMessage', 'setAgree', 'setgRecaptchaResponse', 'resetState']),
            changeEmail(event) {
                this.setEmail(event.target.value);
            },
            changeName(event) {
                this.setName(event.target.value);
            },
            changeMessage(event) {
                this.setMessage(event.target.value);
            },
            changeAgree(event) {
                this.setAgree(event.target.checked ? 1 : 0);
            },
            updateRecaptcha(response) {
                this.setgRecaptchaResponse(response);
            },
            submit() {
                this.send().then(response => {
                    this.formSubmitted = true;
                    this.$refs.captchaContact.execute();
                }).catch(error => {
                    this.errors = error.response.data.errors;
                    if (typeof this.errors === "undefined") {
                        this.errors = {};
                    }
                    if(error.response.data.error_message) {
                        Vue.set(this.errors,'error_message',error.response.data.error_message);
                    }
                    this.onFormInvalid();
                    this.$refs.captchaContact.execute();
                })
            },
            onFormInvalid () {
                document.getElementsByClassName('contact-form-parent')[0].classList.add("h-auto");
                document.getElementsByClassName('contact-form')[1].classList.add("position-relative");
            }
        }
    }
</script>
